<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded && !!link" class="main-container text-center">
      <h5 class="main-header pb-2 text-center pl-2 pr-2 pt-2">Someone thought you’d like this</h5>
      <div class="card-container" ref="cardContainer">
        <div
          class="bookmark-card"
          v-if="link"
        >
          <img ref="previewImage" :src="link.previewImageUrl || '/broken_image_placeholder_small2.png'" alt="Preview" onerror="if (this.src != '/broken_image_placeholder_small2.png') this.src = '/broken_image_placeholder_small2.png'"/>
          <div class="card-body">
            <h5 class="card-description mt-3"><a :href="link.url" target="_blank">{{ link.description }}</a></h5>
            <div class="overflow-hidden text-truncate mb-3">
              <a :href="link.url" target="_blank"><small class="tl-link-small">{{ link.url }}</small></a>
            </div>
            <div>
              <a v-for="tag in link.tags" v-bind:key="tag"
                 :href="'/bookmarks/'+link.owner+'/tag/'+tag"
                   class="badge tl-tag tl-badge icon-grow">
                    {{ tag }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="link" class="swipe-buttons">
        <a id="open-btn"
           class="swipe-btn mr-3"
           :href="link.url"
           target="_blank">
            <span class="bi bi-box-arrow-up-right">
               Open link
            </span>
        </a>
        <div id="more-btn"
            @click="scrollToDiscover"
            class="swipe-btn mr-3">
          <span
                class="bi bi-arrow-down-circle"> See more...
          </span>
        </div>
        <a class="swipe-btn owner"
           data-toggle="tooltip"
           data-placement="right"
           :href="'/bookmarks/' + link.owner"
           target="_blank"
           :title="'see bookmarks of ' + link.owner">
            <span class="bi bi-person-circle">
          </span>
        </a>
      </div>

    </main>

    <div v-if="loaded" class="jumbotron" id="tl-jumbotron" style="margin-bottom: 0px">
      <h4 class="p-3 text-center">Discover more bookmarks...</h4>
      <div class="container">
            <LinkList v-if="discoveryLinks.length > 0" :links="discoveryLinks"/>
      </div>
    </div>

    <section v-if="loaded"  class="hero use-cases">
      <h4>What can you do with <i>just bookmark it?</i></h4>
      <p class="lead mt-5 container text-left" style="max-width: 600px">
        <ul class="list-unstyled lead">
          <li class="mb-1 fade-in">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            Organize messy bookmarks into something you’ll actually use.
          </li>

          <li class="mb-1 fade-in" style="animation-delay: 0.2s;">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            Save links without keeping hundreds of browser tabs open.
          </li>
          <li class="mb-1 fade-in" style="animation-delay: 0.4s;">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            <span><a href="/discover">Discover</a> what your friends are saving.</span>
          </li>
          <li class="mb-1 fade-in" style="animation-delay: 0.6s;">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            Quickly find that article, video, or cool website you saved.
          </li>
          <li class="mb-1 fade-in" style="animation-delay: 0.8s;">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            Always have your bookmarks, no matter the device.
          </li>
          <li class="mb-1 fade-in" style="animation-delay: 1s;">
            <i class="bi bi-check-circle-fill text-success mr-2"></i>
            Collect and organize resources for projects in one place.
          </li>
        </ul>
      </p>

      <br/>

      <a href="#" data-toggle="modal" data-target="#registerEmailModal" class="mt-3 btn btn-lg btn-cta btn-cta-large">Interested? Start the free trial!</a>

    </section>

    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import BackendClient from "@/rest/backend-client";
import Spinner from "@/components/Spinner";
import LinkList from "@/components/LinkList";

export default {
  name: "SharedBookmarkPage",
  head: {
    title: 'just bookmark it! - shared bookmark'
  },
  components: { ErrorPanel, navbar, tlfooter, Spinner, LinkList },
  data() {
    return {
      backendClient: new BackendClient(),
      loaded: false,
      link: null,
      discoveryLinks: []
    };
  },

  props: ['owner', 'linkId'],

  mounted() {
    this.backendClient.getPublicLinkByOwnerAndId(this.owner, this.linkId).then(responseData => {
      this.link = responseData.link;
      this.loaded = true;
    }).catch(e => {
      this.loaded = true;
      throw e;
    });

    this.backendClient.discover().then(responseData => {
      this.discoveryLinks = responseData.links;
    });
  },

  computed: {

  },

  methods: {
    scrollToDiscover() {
      document.querySelector('#tl-jumbotron')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }
};
</script>
<style scoped>

  .main-header {
    color: black;
  }

  .info {
    background-color: #ffc107;
    position: fixed;
    top: 60px;
    right: 10px;
    text-align: right;
    font-size: 20px;
    color: gray
  }

  .main-container {
    background-color: #ffc107;
    background: radial-gradient(circle, #FFA200 1%, rgba(255, 193, 7, 1) 97%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 56px);
    overflow: hidden;
  }

  .card-container {
    position: relative;
    width: 350px;
    height: 450px;
    user-select: none;
  }

  .bookmark-card {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    overflow: hidden;
    background: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, opacity 0.3s ease;
    display: flex;
    flex-direction: column;
  }

  .bookmark-card img {
    width: 100%;
    max-height: 250px;
    object-fit: cover;
  }

  .bookmark-card .card-body {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .swipe-buttons {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .swipe-btn {
    border-radius: 50%;
    border: 1px #777 solid;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    transition: 0.2s;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  }

  #more-btn {
    border-radius: 50px;
    width: auto;
    font-size: 16px;
    padding: 17px;
    background-color: forestgreen;
    color: white;
    cursor: pointer;
  }

  #open-btn {
    border-radius: 50px;
    width: auto;
    font-size: 16px;
    padding: 17px;
    background-color: forestgreen;
    color: white;
    cursor: pointer;
  }

  .swipe-btn:hover {
    transform: scale(1.1);
    text-decoration: none;
  }


  .owner, #open-btn a {
    color: white;
  }

  .owner, #open-btn{
    background-color: cornflowerblue;
  }
</style>
